<template>
  <v-list class="attach-fileList" flat>
    <v-list-item-group v-for="(file, i) in GET_FILE_LIST" :key="i">
      <v-list-item
        class="px-0"
        v-if="file.fileName"
        @click="downloadFile(file)"
      >
        <v-list-item-content>
          <v-list-item-title>
            <file-img-icon v-bind:fileType="file.fileExt" />
            <span v-text="file.fileName"></span>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider v-show="GET_FILE_LIST.length - 1 > i"></v-divider>
    </v-list-item-group>
  </v-list>
</template>

<script>
/* 첨부파일 확인 컴포넌트 */
import FileImgIcon from '@/components/common/FileImgIcon.vue';
import { callApp } from '@/utils/app/callApp.js';
import { downloadFile } from '@/api/file';
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    flag: false,
  }),
  computed: {
    ...mapGetters('ELA', ['GET_FILE_LIST']),
    listShowFlag() {
      return this.GET_FILE_LIST.length > 0;
    },
  },
  methods: {
    async downloadFile(file) {
      try {
        const response = await downloadFile(file);
        callApp.downloadFile({
          dataUrl: response.data,
          fileName: file.fileName,
        });
      } catch (error) {
        alert(error);
      }
    },
  },
  components: {
    FileImgIcon,
  },
};
</script>
<style></style>
